import { passMessageToNative } from "../nativeBridge";
import { waitForCustomEvent } from "../networks/network";

export async function openBarcodeScanner() {
  const scannerEventId = "barcodeScannerEvent"; 

  // JavaScript callback script that logs the scan result and dispatches an event
  const script = `
    try {
      const type = '__type__';
      const value = '__value__';
      console.log('Barcode Scan:', type, value);

      // Dispatch event to capture the scanned result
      window.dispatchEvent(new CustomEvent('${scannerEventId}', { 
        detail: { type, value } 
      }));
    } catch (e) {
      console.error('Barcode scanner script error:', e);
    }
  `;
  passMessageToNative("scanner", {
    callback_script: script,
    variant: "default",
    type: "barcode",
  });
  const eventResult = await waitForCustomEvent(scannerEventId);

  if (eventResult?.detail?.value) {
    return {
      response: eventResult.detail.value,
      error: null,
    };
  }

  return {
    response: null,
    error: "Failed to scan barcode",
  };
}


export async function requestNativeSSO() {
  const script = `
    console.log('__status__', '__id__', '__phone_number__','__err_message__','__id_token__', '__display_name__');
    const res = "__id_token__";
    window.dispatchEvent(new CustomEvent('nativeSsoEvent', {  detail: {res} }));
    `;

  passMessageToNative('sso_login', {
    callback_script: script,
    action: "permission",
    type: "request",
  });
  const eventResult = await waitForCustomEvent("nativeSsoEvent");

  if (eventResult?.detail?.res) {
    return {
      response: eventResult.detail.res,
      error: null,
    };
  }

  return {
    response: null,
    error: "Unable to login",
  };
}
